import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import PayMethod from "./PayMethod";
import ReceiptInfo from "./ReceiptInfo";
import AddressInfo from "./AddressInfo";
import { useEffect, useRef, useState } from "react";
import { useMorningAuthStore } from "../../../../store/useMorningAuthStore";
import { useGetTmpView } from "../../../../hooks/morning/useGetTmpView";
import { usePutAddOrder } from "../../../../hooks/morning/usePutAddOrder";
import { useGetTrackingPop } from "../../../../hooks/morning/useGetTrackingPop";
import { usePutTrackingPop } from "../../../../hooks/morning/usePutTrackingPop";
import { cn } from "hooks/utils/tailwind-utils";

interface ModifyTrackingProps {
    onClose: () => void;
    idx: string;
    done?: boolean;
    infoData?: any;
    className?: string;
}

const ModifyTracking = ({ onClose, idx, done, infoData, className }: ModifyTrackingProps) => {
    // console.log(infoData);
    const payMethodRef = useRef<any>(null);
    const receiptRef = useRef<any>(null);
    const addressInfoRef = useRef<any>(null);
    const c_company = useMorningAuthStore(state => state.c_company ?? "");
    const c_code = useMorningAuthStore(state => state.c_code ?? "");
    const c_req_dept = useMorningAuthStore(state => state.c_req_dept);
    const { data: tmpViewData } = useGetTmpView(idx);
    const { data: trackingData } = useGetTrackingPop(idx);
    const { mutate: putOrder } = usePutAddOrder(() => onClose());
    const { mutate: putTracking } = usePutTrackingPop(() => onClose());
    const [payMethod, setPayMethod] = useState({
        pickup: 1,
        payment: 1,
        count: "",
        weight: "",
        name: "",
        tel: "",
        manager: "",
        postcode: "",
        address: "",
        addressDetail: "",
    });

    const [receipt, setReceipt] = useState({
        name: "",
        tel: "",
        department: "",
        departmentName: "",
        manager: "",
        pickupMessage: "",
        deliveryMessage: "",
    });

    const [depart, setDepart] = useState({
        displayName: tmpViewData?.f_company || "",
        name: tmpViewData?.f_company || "",
        tel: "",
        manager: "",
        mobile: "",
        damCode: "",
        postcode: "",
        address: "",
        addressDetail: "",
        value: "",
        roll: "",
        box: "",
        sample: "",
        f_c_code: "",
    });
    const [arrive, setArrive] = useState({
        name: "",
        tel: "",
        manager: "",
        mobile: "",
        postcode: "",
        address: "",
        addressDetail: "",
    });

    const handleOrderSubmit = () => {
        const isPayMethodValid = payMethodRef.current?.validate?.();
        const isReceiptValid = receiptRef.current?.validate?.();
        const isAddressInfoValid = addressInfoRef.current?.validate?.();

        if (!isPayMethodValid) {
            payMethodRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }
        if (!isReceiptValid) {
            receiptRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }
        if (!isAddressInfoValid) {
            addressInfoRef.current?.scrollIntoView?.({ behavior: "smooth" });
            return;
        }

        const defaultCBranch = "01"; // 기본값
        let c_branch = depart?.value ? (depart.value.trim() !== "" ? depart.value : defaultCBranch) : defaultCBranch;

        // 출발지 - 대구/경북: c_branch 02, 부산/경남: c_branch 04
        const postcodePrefix = depart?.postcode?.slice(0, 2);
        const prefix = postcodePrefix ? parseInt(postcodePrefix, 10) : null;

        if (prefix !== null) {
            if (prefix >= 36 && prefix <= 43) {
                c_branch = "02"; // 대구/경북
            } else if ((prefix >= 46 && prefix <= 49) || (prefix >= 50 && prefix <= 53)) {
                c_branch = "04"; // 부산/경남
            }
        }

        const payload = {
            idx: idx,
            c_code: c_code,
            c_branch: c_branch,
            c_req_dept: c_req_dept ?? "",
            s_kind: payMethod.pickup === 1 ? "H" : "O",
            s_pay_kind: String(payMethod.payment),
            s_cnt: payMethod.count,
            s_weight: payMethod.weight,
            s_pay_company_code: "",
            s_pay_company: payMethod.name,
            s_pay_tel: payMethod.tel,
            s_pay_name: payMethod.manager,
            s_pay_post: payMethod.postcode,
            s_pay_address: payMethod.address,
            s_pay_address_detail: payMethod.addressDetail,
            a_company: c_company,
            a_tel: receipt.tel,
            a_part: receipt.department || receipt.departmentName || "",
            a_part_sn: receipt.department || "",
            a_name: receipt.manager,
            a_request2: receipt.pickupMessage,
            a_request: receipt.deliveryMessage,
            f_c_code: depart.f_c_code,
            // f_company: depart.name,
            f_company: depart.displayName,
            f_tel: depart.tel,
            f_name: depart.manager,
            f_mobile: depart.mobile,
            f_post: depart.postcode,
            f_address: depart.address,
            f_address_detail: depart.addressDetail,
            f_dam_code: depart.damCode,
            t_c_code: "",
            t_company: arrive.name,
            t_tel: arrive.tel,
            t_name: arrive.manager,
            t_mobile: arrive.mobile,
            t_post: arrive.postcode,
            t_address: arrive.address,
            t_address_detail: arrive.addressDetail,
            roll: depart.roll,
            box: depart.box,
            sample: depart.sample,
            ...(done && {
                accept_date: trackingData?.accept_date,
                accept_num: trackingData?.accept_num,
                accept_seq: trackingData?.accept_seq,
            }),
        };
        // console.log("payload", payload);
        // return;

        done ? putTracking(payload) : putOrder(payload);
    };
    useEffect(() => {
        const data = done ? trackingData : tmpViewData;
        if (!data) return;

        setPayMethod({
            pickup: data?.s_kind === "H" ? 1 : 2,
            payment: Number(data?.s_pay_kind),
            count: String(data?.s_cnt ?? ""),
            weight: String(data?.s_weight ?? ""),
            name: data?.s_pay_company ?? "",
            tel: data?.s_pay_tel ?? "",
            manager: data?.s_pay_name || data?.a_name || "",
            postcode: data?.s_pay_post ?? "",
            address: data?.s_pay_address ?? "",
            addressDetail: data?.s_pay_address_detail ?? "",
        });

        setReceipt({
            name: data?.a_company ?? "",
            tel: data?.a_tel ?? "",
            department: data?.a_part_sn ?? "",
            departmentName: data?.a_part ?? "",
            manager: data?.a_name ?? "",
            pickupMessage: data?.a_request2 ?? "",
            deliveryMessage: data?.a_request ?? "",
        });

        setDepart({
            displayName: data?.f_company ?? c_company ?? "",
            name: data?.f_company ?? c_company ?? "",
            tel: data?.f_tel ?? "",
            manager: data?.f_name ?? "",
            mobile: data?.f_mobile ?? "",
            damCode: data?.f_dam_code ?? "",
            address: data?.f_address ?? "",
            addressDetail: data?.f_address_detail ?? "",
            postcode: data?.f_post ?? "",
            roll: data?.roll ? data.roll.toString() : "",
            box: data?.box ? data.box.toString() : "",
            sample: data?.sample ? data.sample.toString() : "",
            value: data?.c_branch,
            f_c_code: data?.f_c_code ?? "",
        });

        setArrive({
            name: data?.t_company ?? "",
            tel: data?.t_tel ?? "",
            manager: data?.t_name ?? "",
            mobile: data?.t_mobile ?? "",
            postcode: data?.t_post ?? "",
            address: data?.t_address ?? "",
            addressDetail: data?.t_address_detail ?? "",
        });
    }, [tmpViewData, trackingData, c_company, done]);

    // console.log(payMethod.pickup);

    return (
        <div className={cn("bg-white overflow-hidden rounded-2xl relative max-w-[650px] w-full mx-[4%]", className)}>
            <div className="flex items-center justify-between px-[4%] pt-6 pb-5">
                <p className="text-2xl font-bold">운송장 수정</p>
                <Close className="cursor-pointer" onClick={() => onClose()} />
            </div>
            <div className="overflow-y-auto max-h-[70vh]">
                <PayMethod ref={payMethodRef} modify data={payMethod} infoData={infoData} setData={setPayMethod} />
                <div className="w-full h-4 bg-[#70737C14]" />
                <ReceiptInfo ref={receiptRef} modify data={receipt} setData={setReceipt} />
                <div className="w-full h-4 bg-[#70737C14] -mt-5" />
                <AddressInfo
                    pickup={payMethod.pickup === 2}
                    infoData={infoData}
                    ref={addressInfoRef}
                    modify
                    depart={depart}
                    setDepart={setDepart}
                    arrive={arrive}
                    setArrive={setArrive}
                    receiptData={receipt}
                    isArriveUseDefault={false}
                    setIsArriveUseDefault={() => {}}
                    payMethodData={payMethod}
                />
            </div>
            <button onClick={handleOrderSubmit} className="abolute w-full bg-[#132E47] text-white h-[58px] text-[20px] font-semibold">
                운송장 수정
            </button>
        </div>
    );
};

export default ModifyTracking;
